export default __webpack_public_path__ + "static/MRV-9c922320f73573f632f223ae5a20c94b.png";